import { useState } from 'react';
import { BLOCK_USER, CHANGE_PASSWORD, CONVERT_TO_PRO, UPDATE_TRADES, UNBLOCK_USER } from '../urls';
import { postAPI } from './ApiCalls';

export const changePassword = ({ data }) => postAPI(CHANGE_PASSWORD, data);
export const blockUser = ({ data }) => postAPI(BLOCK_USER, data);
export const convertToPro = ({ data }) => postAPI(CONVERT_TO_PRO, data);
export const updateTrades = ({ data }) => postAPI(UPDATE_TRADES, data);
export const unblockUser = ({ data }) => postAPI(UNBLOCK_USER, data);

export const useMutateService = mutateFn => {
  const [loading, setLoading] = useState(false);
  return {
    loading,
    mutateAsync: mutateFn,
    mutate: ({ data }, { onSuccess, onError }) => {
      setLoading(true);
      mutateFn({ data }, { onSuccess, onError })
        .then(response => {
          if (!response.error) {
            if (onSuccess) onSuccess(response.data);
          } else {
            if (onError) onError(response.error);
          }
        })
        .finally(() => setLoading(false));
    }
  };
};

export const useChangePassword = () => {
  return useMutateService(changePassword);
};

export const useBlockUser = () => {
  return useMutateService(blockUser);
};

export const useUnblockUser = () => {
  return useMutateService(unblockUser);
};

export const useConvertToPro = () => {
  return useMutateService(convertToPro);
};

export const useUpdateTrades = () => {
  return useMutateService(updateTrades);
};
